<template>
	<div class="text-center">
		<a-spin v-if="isLoading">
			<a-icon slot="indicator" type="loading" style="font-size: 34px;" spin />
		</a-spin>
	</div>
</template>

<script>
export default {
	name: 'Loading',
	props: {
		isLoading: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
}
</script>

<style></style>
